export const urlPattern =
  // eslint-disable-next-line no-useless-escape
  /https?:\/\/(?!www\.[^\s.]+\b(?!\.))[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/gi;
